/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckylotteryItems.vue?vue&type=template&id=c8da3438&scoped=true"
import script from "./popLuckylotteryItems.vue?vue&type=script&lang=js"
export * from "./popLuckylotteryItems.vue?vue&type=script&lang=js"
import style0 from "./popLuckylotteryItems.vue?vue&type=style&index=0&id=c8da3438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8da3438",
  null
  
)

export default component.exports